/** @generated */
// cspell:disable

/** @typedef {import('axios').AxiosInstance} AxiosInstance */

import { SweetPath } from 'sweet-path';

/**
 * @typedef {import('./client-get-list-action-body').ClientGetListActionBody} ClientGetListActionBody
 */

/**
 * @typedef {import('./client-get-list-action-response').ClientGetListActionResponse} ClientGetListActionResponse
 */

/**
 * The path of the ClientGetListAction action.
 */
export const clientGetListActionPath = new SweetPath('/api/project/client', { path: '{param}' });

/**
 * Creates a contextualized ClientGetListAction action.
 *
 * @param {AxiosInstance} axios
 */
export default function createClientGetListAction(axios) {
  /**
   * The clientGetListAction action.
   *
   * @param { { headers: Object<string,string>,parameters: Object<string,string|number|boolean>,query: {limit?: number; offset?: number; filter?: Object<string,string|number|boolean>;, sort?: {by: string; order: string;}} } }
   *
   * @returns {Promise<ClientGetListActionResponse>}
   */
  function clientGetListAction({ headers = {}, parameters = {}, query = {} } = {}) {
    const path = clientGetListActionPath.insert(parameters);

    return axios.get(path, { params: query, headers });
  }

  return clientGetListAction;
}
